module.exports = __webpack_public_path__ + "static/img/6.086c0de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/6.png
// module id = HJM6
// module chunks = 0